import React, { useState, useEffect } from 'react'
import Table, { Cell, Header, Row } from 'components/Table'
import { Popup, Dialog } from 'components/Popup'
import API from 'lib/api'
import { getEndpointToPrintInvoice } from 'lib/commonlyused'

import { SALES_ORDERS_PAY_URL } from 'config/app'
import '../style.scss'
import { getMessage } from 'lib/translator'
import {
  DELIVERY_STATUS,
  ORDER_TYPE,
  ORDER_STATUS,
  hasCompleteFulfilmentAccess,
} from 'pages/operations/SaleOrders/Details/ReDelivery/constant'
import { Link } from 'react-router-dom'

const FullfillmentTable = (props) => {
  const { redelivery = {}, refreshData } = props
  const [fulfillments, setFulfillment] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [successModal, setSuccessModal] = useState(false)
  const [isCancelOrderPopup, setIsCancelOrderPopup] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setFulfillment(redelivery?.fulfilments)
  }, [redelivery])

  if (!redelivery && props.loading) {
    return (
      <div className="p-12">
        <div className="no-delivery">No redelivery data available.</div>
      </div>
    )
  }

  const printInvoice = async () => {
    try {
      setLoading(true)
      const invoiceId = redelivery?.invoiceIds?.[0]
      if (!invoiceId) {
        return
      }
      const apiUrl = getEndpointToPrintInvoice({ invoiceId })
      const invoiceApi = new API({ url: apiUrl })
      const response = await invoiceApi.fileFetch()
      if (response) {
        const blob = new Blob([response], { type: 'application/pdf' })
        const blobURL = URL.createObjectURL(blob)
        window.open(blobURL)
      }
    } catch (e) {
      // ignore
    } finally {
      setLoading(false)
    }
  }

  const handleStatusChange = async (data) => {
    const payLoad = {
      id: data.id,
      items: data.items?.map((item) => {
        return {
          id: item.id,
          fulfilledQuantity: item.orderedQuantity,
        }
      }),
    }

    try {
      const url = `${SALES_ORDERS_PAY_URL}/CompleteFulfilment`
      const api = new API({ url })
      const response = await api.post(payLoad)
      if (response) {
        setFulfillment(
          fulfillments?.map((f) => ({
            ...f,
            deliveryState: response.deliveryState,
          }))
        )
        setSuccessModal(true)
      }
    } catch (error) {
      console.error('Failed to submit redelivery order:', error)
    } finally {
      setIsModalOpen(false)
    }
  }

  const handleCancelOrder = async () => {
    const payLoad = {
      id: props?.match?.params?.id,
    }

    try {
      const url = `${SALES_ORDERS_PAY_URL}/CancelClientSalesOrder`
      const api = new API({ url })
      await api.post(payLoad)
      setIsCancelOrderPopup(false)
      if (refreshData) {
        refreshData()
      }
    } catch (error) {
      console.error('Failed to cancel redelivery order:', error)
      setIsCancelOrderPopup(false)
    }
  }

  const handleClose = () => {
    if (refreshData) {
      refreshData()
    }
    setSuccessModal(false)
  }

  return (
    <>
      <div className="fulfilment-button-container">
        {(redelivery?.state === 'STATE_COMPLETED' ||
          ORDER_STATUS[redelivery?.state] === 'COMPLETED') && (
          <div className="order-actions-web-view">
            <button
              data-testid="print-gift-invoice"
              className="invoice-button print-icon"
              onClick={printInvoice}
              disabled={loading}
            >
              {getMessage('order.details.invoice.printButtonText')}
            </button>
          </div>
        )}
        <button
          className="button primary custom-btn"
          onClick={() => setIsModalOpen(true)}
        >
          View Fulfillments
        </button>
        <Dialog
          show={isCancelOrderPopup}
          information={getMessage(
            'saleOrder.dialog.redelivery.cancel.order.info'
          )}
          close={() => setIsCancelOrderPopup(false)}
          closeText={getMessage(
            'saleOrder.dialog.redelivery.close.cancel.order'
          )}
          onOk={() => handleCancelOrder()}
          okText={getMessage('saleOrder.dialog.redelivery.cancel.order')}
          className="cancel-order-dialog"
        />
        {redelivery?.state === 'STATE_PENDING_FULFILMENT' ? (
          <button
            className="button primary custom-btn ml-10"
            onClick={() => setIsCancelOrderPopup(true)}
          >
            {getMessage('saleOrder.page.redelivery.cancel.order')}
          </button>
        ) : null}
      </div>
      <div className="scrollable-table">
        <Table>
          <Header>
            <Cell>Customer UID</Cell>
            <Cell>Parent Order No.</Cell>
            <Cell>Order No.</Cell>
            <Cell>Order Type</Cell>
            <Cell>Status</Cell>
            <Cell className="text-right"> Total Amount</Cell>
            <Cell className="text-right">Payable Amount</Cell>
          </Header>
          <Row>
            <Cell>{redelivery?.customerUid}</Cell>
            <Cell>
              <Link
                to={`/customer-support/sale-orders/${redelivery?.baseSalesOrder?.id}`}
              >
                {redelivery?.baseSalesOrder?.id}
              </Link>
            </Cell>
            <Cell>{redelivery?.orderNo}</Cell>
            <Cell>{ORDER_TYPE[redelivery?.orderType]}</Cell>
            <Cell>{ORDER_STATUS[redelivery?.state]}</Cell>
            <Cell className="text-right">${redelivery?.totalAmount}</Cell>
            <Cell className="text-right">${redelivery?.payableAmount}</Cell>
          </Row>
        </Table>
      </div>
      <Popup
        show={isModalOpen}
        heading="Fulfillment Details"
        close={() => setIsModalOpen(false)}
        className="module-popup"
      >
        <div className="custom-style">
          {fulfillments?.length > 0 ? (
            fulfillments?.map((fulfillment) => {
              const fulfillmentId = fulfillment.id || 'N/A'
              const status = fulfillment?.deliveryState || 'N/A'
              const date = fulfillment.date
                ? `${fulfillment.date.day}/${fulfillment.date.month}/${fulfillment.date.year}`
                : ''
              const time = fulfillment.timeSlot || ''
              const isPending =
                DELIVERY_STATUS[fulfillment.deliveryState] === 'PENDING'

              return (
                <div key={fulfillmentId} className="scrollable-table custom">
                  <Table>
                    <Header>
                      <Cell>
                        <strong>Status</strong>
                      </Cell>
                      <Cell>
                        <strong>Date</strong>
                      </Cell>
                      <Cell>
                        <strong>Time</strong>
                      </Cell>
                      {isPending && (
                        <Cell>
                          <strong>Action</strong>
                        </Cell>
                      )}
                    </Header>
                    <Row>
                      <Cell>{DELIVERY_STATUS[status]}</Cell>
                      <Cell>{date}</Cell>
                      <Cell>{time}</Cell>

                      <Cell>
                        {isPending && hasCompleteFulfilmentAccess() ? (
                          <button
                            className="button primary ml-10"
                            onClick={() => handleStatusChange(fulfillment)}
                          >
                            Complete
                          </button>
                        ) : (
                          "You don't have access to complete fulfillment."
                        )}
                      </Cell>
                    </Row>
                  </Table>
                </div>
              )
            })
          ) : (
            <p>No fulfillment data found for this order.</p>
          )}
        </div>
      </Popup>
      <Popup
        show={successModal}
        heading="Fulfillment Order Completed"
        close={handleClose}
      >
        <div>{getMessage('order.details.redelivery.completed.order')}</div>
      </Popup>
    </>
  )
}

export default FullfillmentTable
